import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (response) => {
  store.dispatch('wordboard/getWords');
  return response.data;
};

export default wordboard => Vue.$http.post('Wordboards', wordboard).then(success);



// WEBPACK FOOTER //
// ./src/services/wordboard/create.js